import { createAction, props } from "@ngrx/store";
import { PerimeterFirebaseResponse } from "../../models/perimeters.model";
import { User } from "../../models/user.model";

export const LOAD_PERIMETER = '[Perimeter] Load perimeter';
export const LOAD_PERIMETER_SUCCESS = '[Perimeter] Load perimeter success';
export const LOAD_PERIMETER_FAIL = '[Perimeter] Load perimeter fail';
export const ADD_PERIMETER = '[Perimeter] Add perimeter';
export const ADD_PERIMETER_SUCCESS = '[Perimeter] Add perimeter success';
export const ADD_PERIMETER_FAIL = '[Perimeter] Add perimeter fail';
export const UPDATE_PERIMETER = '[Perimeter] Update perimeter';
export const UPDATE_PERIMETER_SUCCESS = '[Perimeter] Update perimeter success';
export const UPDATE_PERIMETER_FAIL = '[Perimeter] Update perimeter fail';

export const LoadPerimeterAction = createAction(
    LOAD_PERIMETER,
    props<{ data: User }>()
);

export const LoadPerimeterSuccessAction = createAction(
    LOAD_PERIMETER_SUCCESS,
    props<{ data: PerimeterFirebaseResponse }>()
);

export const LoadPerimeterFailAction = createAction(
    LOAD_PERIMETER_FAIL,
    props<{ error: Error }>()
);

export const AddPerimeterAction = createAction(
    ADD_PERIMETER,
    props<{ data: PerimeterFirebaseResponse; user: User }>()
);

export const AddPerimeterSuccessAction = createAction(
    ADD_PERIMETER_SUCCESS,
    props<{ data: PerimeterFirebaseResponse }>()
);

export const AddPerimeterFailAction = createAction(
    ADD_PERIMETER_FAIL,
    props<{ error: Error }>()
);

export const UpdatePerimeterAction = createAction(
    UPDATE_PERIMETER,
    props<{ data: PerimeterFirebaseResponse; user: User }>()
);

export const UpdatePerimeterSuccessAction = createAction(
    UPDATE_PERIMETER_SUCCESS,
    props<{ data: PerimeterFirebaseResponse }>()
);

export const UpdatePerimeterFailAction = createAction(
    UPDATE_PERIMETER_FAIL,
    props<{ error: Error }>()
);
